import React from 'react';
import '../App.css';
import PostEditor from './PostEditor';

export default class MessageCreator extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  submitMessage(event) {
    event.preventDefault();
    console.log('Submitting message...');
    console.log('State message is : ' + this.state.messageBody);
    let message = this.state.messageBody;
        // url = window.location.protocol + '//' + window.location.host,
    let  fullUrl = '';
    
    if (this.props.conversationId) {
      fullUrl = `/api/v1/conversations/${this.props.conversationId}/messages`;
    } else {
      fullUrl = `/api/v1/messages`;
    }
    let reqData = new FormData();
    let that = this;
    reqData.append('message[body]', message);
    if (!this.props.conversationId) {
      reqData.append('message[neighbors]', this.props.neighbors);
    }
    if (this.props.messageId) {
      reqData.append('message_id', this.props.messageId);
    }
    let data = {
      method: 'POST',
      body: reqData
    };
    try {
      fetch(fullUrl, data, function(err, data) {
        if (err) {
          console.log('Error submitting new post!: ' + err);
        }
        if (data) {
          // Message bus handles sticking the new mesage into the message viewer div.. 
          that.setState({messageBody: ''});
        }   
      }); 
    } catch(e) {
      console.log('Post creation error: ' + e); 
    }   
  }

  updateMessageBody(data) {
    this.setState({messageBody: data});
  }

  clearState() {
    console.log('Clear state has been called!');
  }

  addMessage(e) {
    if (e.keyCode === 13 && e.shiftKey === false) {
      this.submitMessage(e);
    }
  }

  showPostEditor(e) {
    if (e) e.preventDefault();
    this.setState({showPostEditor: true});
  }

  render() {
    console.log('Rendering MessageCreator div...');
    let input = '';
    if (this.state.showPostEditor) {
      input = <PostEditor user={this.props.user} app={this.props.app} messageCreator={this} conversationId={this.props.conversationId} />;
    } else {
      input = <form onSubmit={(e) => this.submitMessage(e)}>
          <img className='avatar' src={this.props.user.avatar} alt={this.props.user.username} style={{width: '30px'}} />
          &nbsp;&nbsp;
          <textarea className='messageBodyInput' rows={6} size={8}
                        onKeyDown={(e) => this.addMessage(e)}
                        onChange={(e) => this.updateMessageBody(e.target.value)}
                        value={this.state.messageBody || ''} ref={(ref) => this._messageInput = ref} />
          <button type='button' onClick={(e) => this.showPostEditor(e)} className='smallSubmitButton' style={{verticalAlign: 'top', float: 'right'}}>Post</button>
          <button type='submit' className='smallSubmitButton' style={{verticalAlign: 'top', float: 'right'}}>Submit</button>
        </form>;
    }
    return (
      <div className='messageCreator'>
        {input}
      </div>
    );
  }
}
